<script setup>
defineProps({
  isDisabled: {
    type: Boolean,
    default: false,
  },
  isClicked: {
    type: Boolean,
    default: false
  }
});

</script>

<template>
  <div
    class="globus-button-primary"
    :class="{'globus-button-primary_disabled': isDisabled, 'globus-button-primary_clicked': isClicked}"
  >
    <slot />
  </div>
</template>

<style scoped lang="scss">

.globus-button-primary {
  display: flex;
  justify-content: center;
  align-items: center;
  background: $primary-button-background;
  color: $primary-button-color;
  border-radius: 8px;
  gap: 4px;
  padding: 6px 15px 6px 15px;
  height: 42px;
  cursor: pointer;
  user-select: none;

  &:hover {
    background: $primary-button-hover-background;
  }

  &_clicked {
    cursor: not-allowed;
    pointer-events: none;
    background: $primary-button-hover-background;
  }

  &_disabled {
    cursor: not-allowed;
    pointer-events: none;
    background: $primary-button-disabled-background;

    &:hover {
      background: $primary-button-disabled-background;
    }
  }
}
</style>
